<template>
    <div>
        <div id="table_box" style="margin-bottom: 20px;">
            <el-table v-if="tableData && tableData.length > 0" :data="tableData" :header-cell-style="tableHeaderStyle"
                      style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="100" align="center">
                </el-table-column>
                <el-table-column
                    prop="dealTitle"
                    label="待办内容"
                >
                </el-table-column>
                <el-table-column
                    prop="createDate"
                    label="接收时间"
                >
                </el-table-column>
                <el-table-column width="200"
                                  label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="modify(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'supplierTodoTable',
        data(){
            return {
                tableData: [],
                form: {

                },

                tableHeaderStyle:{
                    'background-color': '#F6F6F6',
                    'height': '40px',
                    'color': '#333333',
                },
            }
        },
        components: {
        },
        created(){
            this.getData();
        },
        methods:{
          modify(row){
            this.$router.push("/register?supplierId=" + row.relatedId)
          },
            getData(){
                let that = this;
                let params = Object.assign({}, this.form);

                let url = '/v1/outerformflowHS/getSupplierDeal';
          
                this.$root.postHttp(url, params, (res) => {
                    that.tableData = res.data.data;
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import '../assets/_var.scss';
    .search_box{
        text-align: left;
        .el-form-item /deep/{
            width: 300px;
            display: inline-block;
            .el-input__inner{
                border-radius: 0!important;
            }
        }
        .fr{
            float: right;
            color: #333333;
            font-size: 16px;
        }
    }
    #table_box /deep/{
        .table_header th{
            background-color: #F6F6F6!important;
        }

        .el-table th, .el-table td {
            padding: 0px 0;
            font-size: 12px;
        }

        .el-table__body-wrapper {
            font-size: 13px;
        }
        .el-button.el-button--text {
            font-size: 13px;
            padding: 0px;
        }
        .el-table .cell {
            line-height: 32px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/supplierTodoTable.vue